import { PkDialog } from '@uefadigital/panenka-react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { memo, useMemo } from 'react';

import type { EditorialContent } from '@cobalt/utilities';
import { useWindowSize } from '@hooks/useWindowSize';
import ReactPortal from '@shared/ReactPortal';
import VideoPlayer from '@shared/VideoPlayer';

import * as styles from './styles.module.scss';

dayjs.extend(duration);
dayjs.extend(relativeTime);

const VideoDialog = ({
  teaser,
  openOverlay,
  setOpenOverlay,
}: {
  teaser: EditorialContent;
  openOverlay: boolean;
  setOpenOverlay: (value: boolean) => void;
}) => {
  const { isMobile } = useWindowSize();

  const handleOverlayClose = () => {
    setOpenOverlay(false);
  };

  const timeAgo = useMemo(() => {
    if (!teaser.firstPublicationDate) return '';

    const d = dayjs(teaser.firstPublicationDate);
    if (dayjs().diff(d, 'day') > 14) {
      return d.format('ll');
    }

    return d.fromNow();
  }, [teaser.firstPublicationDate]);

  return (
    <ReactPortal>
      <PkDialog
        pk-theme='dark'
        className={styles.dialog}
        isOpen={openOverlay}
        onPkClose={handleOverlayClose}
        size={isMobile ? 'full' : 'small'}
      >
        <div
          className='pk-w--100 pk-font-size--xs pk-line-height--lg pk-font--base-regular pk-text--text-01'
          slot='header'
        >
          {timeAgo}
        </div>
        <div className='pk-w--100 pk-h--100 pk-overflow--hidden' slot='body'>
          {openOverlay && (
            <VideoPlayer
              wrapperClassName={styles.dialogPlayer}
              controls
              showTitle
              repeat
              isAutoPlay='viewable'
              isMuted={false}
              disableFullscreen
              aspectratio='9:16'
              teaser={teaser}
            />
          )}
        </div>
      </PkDialog>
    </ReactPortal>
  );
};

export default memo(VideoDialog);
